import * as type from '../../../actions/index.types'

export function InvoiceTypeReducers(state = {
    loading: false,
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
    invoiceTypesData: null,
    invoiceTypeDetails: null,
    pagination: null,
    error: null
}, action) {

    switch (action.type) {
        // Get Invoice Types
        case type.GET_INVOICE_TYPES:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.GET_INVOICE_TYPES_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                invoiceTypesData: action.payload?.data,
                pagination: action.payload?.meta?.pagination,
            }
        }
        case type.GET_INVOICE_TYPES_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        // Get Invoice Type Details
        case type.GET_INVOICE_TYPE_DETAILS:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.GET_INVOICE_TYPE_DETAILS_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                invoiceTypeDetails: action.payload,
            }
        }
        case type.GET_INVOICE_TYPE_DETAILS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        // Create Invoice Type
        case type.CREATE_INVOICE_TYPE:
            return {
                ...state,
                createLoading: true,
                error: null,
            }
        case type.CREATE_INVOICE_TYPE_SUCCESS: {
            return {
                ...state,
                error: null,
                createLoading: false,
            }
        }
        case type.CREATE_INVOICE_TYPE_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                createLoading: false,
            }

        // Update Invoice Type
        case type.UPDATE_INVOICE_TYPE:
            return {
                ...state,
                updateLoading: true,
                error: null,
            }
        case type.UPDATE_INVOICE_TYPE_SUCCESS: {
            return {
                ...state,
                error: null,
                updateLoading: false,
            }
        }
        case type.UPDATE_INVOICE_TYPE_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                updateLoading: false,
            }

        // Delete Invoice Type
        case type.DELETE_INVOICE_TYPE:
            return {
                ...state,
                deleteLoading: true,
                error: null,
            }
        case type.DELETE_INVOICE_TYPE_SUCCESS: {
            return {
                ...state,
                error: null,
                deleteLoading: false,
            }
        }
        case type.DELETE_INVOICE_TYPE_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                deleteLoading: false,
            }

        default:
            return state
    }
}
